import {
  DashboardContainer,
  TransactionContainer,
  SignedUpBusinessesContainer,
  InvoiceReceiptContainer,
  AdminContainer,
  BillsContainer,
  ExchangeRateContainer,
  WalletContainer,
  AuditContainer,
  SettingsContainer,
  ReconBillsContainer,
  BusinessCategoryContainer,
  FaqsCategoryContainer,
  FaqsContainer,
  ChargeAnalysisContainer,
  ExpenseCategoryContainer,
  SubscriptionContainer,
  ApproveBankContainer,
  ExchangeTransactionsContainer,
  ChargeContainer,
  SupportContainer,
  FeedbackResContainer,
  FeedbackConfigContainer,
  SplitPaymentsContainer,
  KudaTransactionsContainer,
  ProvidusTransactionsContainer,
  PublicCatalogueContainer,
  PayoutContainer,
  NewsContainer,
  MarketersContainer,
  MarketersAnalysisContainer,
  ViewMoreNewsContainer,
  BroadcastContainer,
  CreateBroadcastContainer,
  ViewMoreBroadcastContainer,
  ForeignBankAccountsContainer,
  FashBusinessesContainer,
  StyleCategoriesContainer,
  UpdateBroadcastContainer,
  MoneyExAdsContainer,
  MoneyExUsersContainer,
  MoneyExExpressOrdersContainer,
  MoneyExP2POrdersContainer,
  MoneyExLimitContainer,
  PaymentMethodContainer,
  ProspectsContainer,
  CloneBroadcastContainer,
  CompetitionsContainer,
  VotesContainer,
  ParticipantsContainer,
} from "../containers";
import {
  BankAccountListContainer,
  CreateInflowContainer,
  CreateOutflowContainer,
  WalletTransactionsContainer,
} from "../containers/WalletContainer";

import { FashThemes } from "../pages";

import constant from "../utils/constant";

const protectedRoutes = [
  {
    path: constant.Routes.AdminDashboard,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <DashboardContainer />,
  },
  {
    path: constant.Routes.Transaction,
    module: "TRANSACTION",
    type: "GENERAL",
    element: <TransactionContainer />,
  },
  {
    path: constant.Routes.KudaTransactions,
    // module: "TRANSACTION",
    type: "GENERAL",
    element: <KudaTransactionsContainer />,
  },
  {
    path: constant.Routes.ProvidusTransactions,
    // module: "TRANSACTION",
    type: "GENERAL",
    element: <ProvidusTransactionsContainer />,
  },
  {
    path: constant.Routes.Wallet,
    module: "WALLET",
    type: "GENERAL",
    element: <WalletContainer />,
  },
  {
    path: constant.Routes.CreateInflow,
    module: "WALLET",
    type: "GENERAL",
    element: <CreateInflowContainer />,
  },
  {
    path: constant.Routes.CreateOutflow,
    module: "WALLET",
    type: "GENERAL",
    element: <CreateOutflowContainer />,
  },
  {
    path: constant.Routes.WalletTransactions,
    module: "WALLET",
    type: "GENERAL",
    element: <WalletTransactionsContainer />,
  },
  {
    path: constant.Routes.SignedUpBusineses,
    module: "BUSINESS DETAILS",
    type: "GENERAL",
    element: <SignedUpBusinessesContainer />,
  },
  {
    path: constant.Routes.Bills,
    module: "BILL PAYMENT",
    type: "GENERAL",
    element: <BillsContainer />,
  },
  {
    path: constant.Routes.ReconcileBills,
    module: "BILL PAYMENT",
    type: "GENERAL",
    element: <ReconBillsContainer />,
  },
  {
    path: constant.Routes.InvoiceReceipt,
    module: "INVOICE/RECEIPT",
    type: "GENERAL",
    element: <InvoiceReceiptContainer />,
  },
  {
    path: constant.Routes.Admin,
    module: "ADMIN",
    type: "GENERAL",
    element: <AdminContainer />,
  },
  {
    path: constant.Routes.ExchangeRate,
    module: "EXCHANGE",
    type: "GENERAL",
    element: <ExchangeRateContainer />,
  },
  {
    path: constant.Routes.SplitPayment,
    // module: "SPLITPAYMENT",
    type: "GENERAL",
    element: <SplitPaymentsContainer />,
  },
  {
    path: constant.Routes.Audit,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <AuditContainer />,
  },
  {
    path: constant.Routes.Settings,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <SettingsContainer />,
  },
  {
    path: constant.Routes.BusinessCategory,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <BusinessCategoryContainer />,
  },
  {
    path: constant.Routes.FaqsCategory,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <FaqsCategoryContainer />,
  },
  {
    path: constant.Routes.Faqs,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <FaqsContainer />,
  },
  {
    path: constant.Routes.ChargeAnalysis,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <ChargeAnalysisContainer />,
  },
  {
    path: constant.Routes.ExpenseCategory,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <ExpenseCategoryContainer />,
  },
  {
    path: constant.Routes.Subscription,
    // module: 'TRANSACTION',
    type: "GENERAL",
    element: <SubscriptionContainer />,
  },
  {
    path: constant.Routes.ApproveBank,
    module: "WALLET",
    type: "GENERAL",
    element: <ApproveBankContainer />,
  },
  {
    path: constant.Routes.ExchangeTransactions,
    // module: 'WALLET',
    type: "GENERAL",
    element: <ExchangeTransactionsContainer />,
  },
  {
    path: constant.Routes.Charge,
    // module: 'WALLET',
    type: "GENERAL",
    element: <ChargeContainer />,
  },
  {
    path: constant.Routes.Support,
    // module: 'WALLET',
    type: "GENERAL",
    element: <SupportContainer />,
  },
  {
    path: constant.Routes.FeedbackRes,
    // module: 'WALLET',
    type: "GENERAL",
    element: <FeedbackResContainer />,
  },
  {
    path: constant.Routes.FeedbackConfig,
    // module: 'WALLET',
    type: "GENERAL",
    element: <FeedbackConfigContainer />,
  },
  {
    path: constant.Routes.BankAccountList,
    // module: 'WALLET',
    type: "GENERAL",
    element: <BankAccountListContainer />,
  },
  {
    path: constant.Routes.FashPublicCatalogue,
    // module: 'CUSTOMER',
    element: <PublicCatalogueContainer />,
  },
  {
    path: constant.Routes.Payout,
    // module: 'CUSTOMER',
    element: <PayoutContainer />,
  },
  {
    path: constant.Routes.News,
    // module: 'CUSTOMER',
    element: <NewsContainer />,
  },
  {
    path: constant.Routes.Marketers,
    // module: 'CUSTOMER',
    element: <MarketersContainer />,
  },
  {
    path: constant.Routes.MarketersAnalysis,
    // module: 'CUSTOMER',
    element: <MarketersAnalysisContainer />,
  },
  {
    path: constant.Routes.ViewMoreNews,
    // module: 'CUSTOMER',
    element: <ViewMoreNewsContainer />,
  },
  {
    path: constant.Routes.Broadcast,
    // module: 'CUSTOMER',
    element: <BroadcastContainer />,
  },
  {
    path: constant.Routes.CreateBroadcast,
    // module: 'CUSTOMER',
    element: <CreateBroadcastContainer />,
  },
  {
    path: constant.Routes.UpdateBroadcast,
    // module: 'CUSTOMER',
    element: <UpdateBroadcastContainer />,
  },
  {
    path: constant.Routes.CloneBroadcast,
    // module: 'CUSTOMER',
    element: <CloneBroadcastContainer />,
  },
  {
    path: constant.Routes.ViewMoreBroadcast,
    // module: 'CUSTOMER',
    element: <ViewMoreBroadcastContainer />,
  },
  {
    path: constant.Routes.ForeignBankAccounts,
    // module: 'CUSTOMER',
    element: <ForeignBankAccountsContainer />,
  },
  {
    path: constant.Routes.FashBusinesses,
    // module: 'CUSTOMER',
    element: <FashBusinessesContainer />,
  },
  {
    path: constant.Routes.StyleCategories,
    // module: 'CUSTOMER',
    element: <StyleCategoriesContainer />,
  },
  {
    path: constant.Routes.Competitions,
    // module: 'CUSTOMER',
    element: <CompetitionsContainer />,
  },
  {
    path: constant.Routes.Participants,
    // module: 'CUSTOMER',
    element: <ParticipantsContainer />,
  },
  {
    path: constant.Routes.Votes,
    // module: 'CUSTOMER',
    element: <VotesContainer />,
  },
  {
    path: constant.Routes.MoneyExAds,
    // module: 'CUSTOMER',
    element: <MoneyExAdsContainer />,
  },
  {
    path: constant.Routes.MoneyExUsers,
    // module: 'CUSTOMER',
    element: <MoneyExUsersContainer />,
  },
  {
    path: constant.Routes.MoneyExExpressOrders,
    // module: "WALLET",
    element: <MoneyExExpressOrdersContainer />,
  },
  {
    path: constant.Routes.MoneyExP2POrders,
    // module: "WALLET",
    element: <MoneyExP2POrdersContainer />,
  },
  {
    path: constant.Routes.MoneyExLimit,
    // module: "WALLET",
    element: <MoneyExLimitContainer />,
  },
  {
    path: constant.Routes.PaymentMethod,
    // module: "WALLET",
    element: <PaymentMethodContainer />,
  },
  {
    path: constant.Routes.Prospects,
    // module: "WALLET",
    element: <ProspectsContainer />,
  },
  {
    path: constant.Routes.Themes,
    // module: "WALLET",
    element: <FashThemes />,
  },
];

export default protectedRoutes;
